/**
 * SaltaCompra Design System
 *
 * Sistema de diseño profesional con soporte para múltiples temas
 *
 * @example
 * ```tsx
 * import { useTheme, ThemeControl } from '@/lib/design-system';
 *
 * function MyComponent() {
 *   const { resolvedTheme } = useTheme();
 *   return <ThemeControl />;
 * }
 * ```
 *
 * NOTA (Fase 5 / #73): la capa de valores TS (tokens/colors, tokens/typography,
 * tokens/spacing, tokens/index, themes/light, themes/dark, themes/index) fue
 * eliminada — tenía 0 importadores en runtime. La fuente de verdad de color en
 * runtime es `src/app/globals.css`. Solo se conservan los TIPOS de tema
 * (`themes/types.ts`), que `ThemeContext` consume como type-only import.
 */

// =================================
// THEMES (solo tipos)
// =================================

export type {
  ThemeMode,
  ResolvedTheme,
  ThemeName,
  ThemeConfig,
  ThemeCSSVariables,
  ThemeContextValue,
  ThemeProviderProps,
  UserThemePreferences,
} from './themes/types';

// =================================
// CONTEXT & HOOKS
// =================================

export {
  ThemeProvider,
  useTheme,
  useResolvedTheme,
  useThemeLoaded,
  useThemeUserSync,
  THEME_CONFIG,
} from './context/ThemeContext';

// =================================
// COMPONENTS
// =================================

// DS-5 (ADR-0028 dec. 6): `ThemeToggle`/`ThemeSwitcher` propios RETIRADOS.
// El único control es `ThemeControl` (theme-switcher de familia, controlado).
export {
  ThemeControl,
} from './components/index';

// =================================
// UTILITIES
// =================================

// La ex-fachada de persistencia (localStorage/servidor/preferencia del sistema)
// fue borrada: sin consumidores en runtime. Lo único vivo es el canal de broadcast.
export {
  createThemeBroadcastChannel,
} from './utils/persistence';
